import {fieldPathJoinGetter} from "../../utils/kp3Utils";

export const entity = {
    name: "MaturityControl",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {
                const translate = context?.translateName || (w => w)
                return callback(null, object.name && translate(object.name))
            }
        },
        fieldPathJoinGetter({
            path: "codeName",
            fieldPath: ["code", "translatedName"],
            joinString: " - "
        })
    ]
}

export const module_ = {
    object: "MaturityControl",
    tKey: "mTitle_maturityControl",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "code"},
            {path: "name", type: "textarea"},
        ]
    }
}